import { render, staticRenderFns } from "./DelegationOrderDecisionView.vue?vue&type=template&id=03751eca&scoped=true&"
import script from "./DelegationOrderDecisionView.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderDecisionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03751eca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03751eca')) {
      api.createRecord('03751eca', component.options)
    } else {
      api.reload('03751eca', component.options)
    }
    module.hot.accept("./DelegationOrderDecisionView.vue?vue&type=template&id=03751eca&scoped=true&", function () {
      api.rerender('03751eca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation-order/DelegationOrderDecisionView.vue"
export default component.exports